import { ArrowRight } from '@nick-mazuk/ui/elements/icon'
import { Image } from '@nick-mazuk/ui/elements/image'
import { Link } from '@nick-mazuk/ui/elements/link'
import { Text } from '@nick-mazuk/ui/elements/text'

type Properties = {
    artist: string
    url: string
    image: string
    title: string
    index: number
}

export const SpotifyTrack = ({ artist, url, image, title, index }: Properties): JSX.Element => {
    return (
        <div className='flex items-center max-w-xs mx-auto mt-8 overflow-hidden rounded-lg shadow-md bg-gray-d50 sm:overflow-visible xl:-ml-20 sm:bg-transparent sm:rounded-none sm:shadow-none sm:max-w-none sm:mx-0'>
            <div className='relative self-stretch hidden px-10 text-4xl select-none sm:block'>
                <span className='absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2'>
                    <Text h3 as='span' color='text-gray-d100'>
                        {index + 1}
                    </Text>
                </span>
            </div>
            <Link href={url} className='flex-1 min-w-0'>
                <div className='flex flex-col items-center sm:overflow-hidden sm:rounded-lg sm:transition-all sm:duration-150 sm:transform sm:bg-gray-d50 sm:shadow-md sm:flex-row sm:hover:shadow-lg sm:hover:scale-101 sm:active:scale-105 sm:active:shadow-xl'>
                    <div className='w-full sm:w-24 min-w-24'>
                        <div>
                            <Image src={image} alt={title} ratio='1x1' />
                        </div>
                    </div>
                    <div className='flex-1 w-full min-w-0 p-5 pb-3 sm:pl-6 sm:pr-0 sm:py-0 sm:w-auto'>
                        <Text h6 as='p' truncate color='text-gray-d700'>
                            <span className='sm:hidden'>{index + 1}. </span>
                            {title}
                        </Text>
                        <Text truncate small color='text-gray-d600'>
                            {artist}
                        </Text>
                    </div>
                    <p className='flex items-center self-stretch px-5 pb-5 whitespace-no-wrap text-gray-d600 sm:pl-8 sm:pr-6 sm:py-0 justify-self-end hover:text-gray-d800'>
                        <Text span small>
                            Listen on Spotify
                        </Text>
                        <span className='ml-1'>
                            <ArrowRight width='w-4' />
                        </span>
                    </p>
                </div>
            </Link>
        </div>
    )
}

export type SpotifyTrack = ReturnType<typeof SpotifyTrack>
